import { getRequiredConfig } from '@klpkonsern/appconfig';

declare global {
    interface AppConfigParameters {
        WEBAPP_APP_SUPEROFFICE_LINK: string;
    }
}

export const getSuperofficeLink = () =>
    getRequiredConfig('WEBAPP_APP_SUPEROFFICE_LINK');

export const getSuperofficeLinkWithClientId = (soClientId: number) =>
    getSuperofficeLink().concat(
        '?contact.main.personarchive?contact_id=',
        soClientId.toString(),
    );
